<template>
    <div>
        <h1 class="h3 mb-3 text-gray-800">
            {{ $t("Devolutiva da Referência/Contrarreferência") }} #{{
                item.protocolo
            }}
        </h1>

        <loading-animation
            :active.sync="loading"
            :is-full-page="false"
            :opacity="1"
            color="#5895FF"
        />
        <div id="boxPrint" class="row">
            <div class="col-md-12">
                <table
                    class="table b-table b-table-stacked-md table-bordered table-sm bg-white"
                >
                    <tbody>
                        <tr>
                            <td>
                                PROTOCOLO: <strong>{{ item.protocolo }}</strong>
                            </td>
                            <td>
                                CADASTRADO:
                                <strong>{{ item.cadastrado }}</strong>
                            </td>
                            <td>
                                ATUALIZADO:
                                <strong>{{ item.atualizado }}</strong>
                            </td>
                            <td>
                                STATUS:
                                <b v-html="item.status_nome"></b>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="2">
                                TIPO: <b v-html="item.tipo_nome"></b>
                            </td>
                            <td colspan="2">
                                FAMÍLIA:
                                <b-link
                                    v-b-tooltip.hover
                                    title="Ver o prontuário da família"
                                >
                                    #{{ item.familia_id }}
                                    <i class="fas fa-external-link-alt"></i>
                                </b-link>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="4">
                                USUÁRIO(S) ATENDIDO(S):
                                <strong
                                    class="mr-2"
                                    v-for="(
                                        pessoa, index
                                    ) in item.pessoas_objetos"
                                    :key="pessoa.id"
                                >
                                    {{ pessoa.nome_completo }}
                                    <span
                                        v-if="
                                            index <
                                            item.pessoas_objetos.length - 1
                                        "
                                        >,</span
                                    >
                                </strong>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="2">
                                TÉCNICO RESPONSÁVEL:<b v-if="item.user">{{
                                    item.user.name
                                }}</b>
                            </td>
                            <td colspan="2">
                                UNIDADE DE ORIGEM:
                                <b v-if="item.unidade">{{
                                    item.unidade.nome
                                }}</b>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="2">
                                UNIDADE DE INTERVENÇÃO:
                                <b v-if="item.unidade_destino">{{
                                    item.unidade_destino.nome
                                }}</b>
                            </td>
                            <td colspan="2">
                                TÉCNICO NA UNIDADE DE INTERVENÇÃO:
                                <b v-if="item.user_destino">{{
                                    item.user_destino.name
                                }}</b>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="4">
                                SITUAÇÃO IDENTIFICADA:
                                <div v-html="item.situacao_identificada"></div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="col-md-12">
                <div class="card shadow">
                    <div class="card-body">
                        <div class="row">
                            <form @submit.prevent="submit" ref="addItem">
                                <div class="col-md-12">
                                    <h4>Cadastrar Devolutiva</h4>
                                    <div class="row">
                                        <form-textarea-editor
                                            v-model="
                                                item.intervencoes_realizadas
                                            "
                                            grid="12"
                                            label="Intervenções Realizadas"
                                            :required="true"
                                        />

                                        <form-textarea-editor
                                            v-model="item.avaliacao_superacao"
                                            grid="12"
                                            label="Avaliação da Equipe sobre a superação das problemáticas encaminhadas"
                                            :required="true"
                                        />

                                        <form-file
                                            @submit="submitFile"
                                            multiple
                                            btn-text="Iniciar"
                                            :progress="progressCompleted"
                                        />
                                    </div>
                                    <div
                                        class="row pt-4 px-0 d-flex justify-content-end"
                                    >
                                        <div class="col-auto px-2 text-right">
                                            <b-link
                                                class="btn btn-default"
                                                :to="
                                                    '/dashboard/referenciamentos/show/' +
                                                    item.id
                                                "
                                            >
                                                <i class="mdi mdi-arrow-left" />
                                            </b-link>

                                            <b-link
                                                class="btn btn-success btn-submit"
                                                @click.prevent="
                                                    validaCamposeShowModal();
                                                    statusAtual =
                                                        statusFinalizado[0].id;
                                                "
                                            >
                                                <i
                                                    class="mdi mdi-content-save"
                                                />
                                                {{ $t("Salvar") }}
                                            </b-link>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <status-historico
            v-if="status"
            :model="model"
            modulo="Referencia"
            titulo_modulo="REFERÊNCIA/CONTRARREFERÊNCIA AO CADASTRAR A DEVOLUTIVA"
            :id="item.id"
            :status-anterior="statusAnterior"
            :status-atual="statusAtual"
            :status="status_item"
            @submit="submit"
        />
    </div>
</template>
<script>
export default {
    name: "Show",
    data() {
        return {
            loading: true,
            item: {
                intervencoes_realizadas: "",
                avaliacao_superacao: "",
            },
            user_id: this.$store.state.user.id,
            tecnico_id: null,
            unidade_id: null,
            progressCompleted: 0,
            files: [],
            statusAtual: "",
            statusAnterior: "",
            status: {},
            status_item: [],
            model: "Referencia",
            statusFinalizado: [{}],
        };
    },
    mounted() {
        this.getStatus();
        this.getItem();
        this.getStatusFinais();
    },
    methods: {
        submitFile(files) {
            this.files = files;
        },
        getItem() {
            this.loading = true;
            axios
                .get(`api/dashboard/referenciamentos/${this.$route.params.id}`)
                .then((response) => {
                    this.tecnico_id = this.$store.state.user.tecnico.id;
                    this.item = response.data.data;
                    this.statusAnterior = this.item.status;
                    this.unidade_id = this.$store.state.user.unidade.id;
                    this.loading = false;
                })
                .catch((error) => {
                    swal.fire({
                        title: "Ops!",
                        html:
                            "A Referência/Contrarreferência não foi carregada corretamente<br>" +
                            error,
                        icon: "error",
                    });
                });
        },
        getStatus() {
            axios
                .get(`api/dashboard/status/referenciamentos`)
                .then((response) => {
                    this.status = response.data;
                    this.statusFinalizado = this.status.filter((item) => {
                        return item.value == "FINALIZADO";
                    });
                });
        },
        getStatusFinais() {
            axios
                .post(`api/dashboard/get/status/finais`, {
                    model: this.model,
                    module: this.model,
                })
                .then((response) => {
                    this.status_item = response.data;
                });
        },
        submit() {
            this.item.status = this.statusAtual;
            this.item.devolutiva = "ok";

            let formData = new FormData();

            if (this.files.length > 0 && this.files.length != undefined) {
                for (const i of Object.keys(this.files)) {
                    formData.append("files[]", this.files[i]);
                }
            } else {
                formData.append("files", this.files);
            }

            for (var key in this.item) {
                formData.append(key, this.item[key]);
            }

            let ladda = Ladda.create(document.querySelector(".btn-submit"));
            ladda.start();

            axios
                .post(`api/dashboard/update/referenciamento`, formData, {
                    header: { "Content-Type": "multipart/form-data" },
                    onUploadProgress: (event) => {
                        let progress = Math.round(
                            (event.loaded * 100) / event.total
                        );
                        this.progressCompleted = progress;
                    },
                })
                .then((response) => {
                    this.$snack.success({
                        button: false,
                        text: response.data.data.message,
                    });
                    this.getItem();
                })
                .finally(() => {
                    this.progressCompleted = 0;
                    this.files = [];
                    this.$router.push(
                        "/dashboard/referenciamentos/show/" + this.item.id
                    );
                });
        },
        validaCamposeShowModal() {
            if (
                !this.item.intervencoes_realizadas ||
                !this.item.avaliacao_superacao
            ) {
                swal.fire({
                    title: "Error",
                    html: "Os campos Intervenções Realizadas e Avaliação da Equipe sobre a superação das problemáticas encaminhadas são obrigatórios",
                    icon: "error",
                });
            } else {
                this.$bvModal.show("status-historico-" + this.model);
            }
        },
    },
};
</script>
